import { CookieBanner as ConsentBanner } from '@web-common/ui/cookie-banner';
import { datadogLogs } from '@datadog/browser-logs';
import { useCookieBannerStore } from '@web-common/utils';

export default function CookieBanner({
  locale,
  cookiesUrl = '/cookies',
}: {
  locale: string;
  cookiesUrl?: string | null;
}) {
  const { open, setOpen } = useCookieBannerStore();

  return (
    <ConsentBanner
      lang={locale as 'no' | 'en'}
      open={open}
      cookiesUrl={cookiesUrl || '/cookies'}
      onConsentComplete={(consent) => {
        setOpen(false);
        datadogLogs.setTrackingConsent(
          consent.analytics ? 'granted' : 'not-granted',
        );
      }}
      onClose={() => {
        setOpen(false);
      }}
    />
  );
}
